import React, { useState } from 'react';

import isBlankString from '../../helpers/is-blank-string';
import { setCookie } from '../../helpers/cookie';

function AlertPopup({ status, message, title, button, link, func }) {
  const [isLoading, setIsLoading] = useState(false);

  const defaults = {
    titles: {
      success: 'Отлично!',
      error: 'Ошибка',
      warning: 'Вы уверены?',
    },
    buttons: {
      success: 'Хорошо',
      error: 'Назад',
      warning: 'Продолжить',
    },
  };

  const btn = isBlankString(button) ? defaults.buttons[status] : button;
  const classes = ['btn'];

  if (status === 'warning') classes.push('btn--outline');

  isLoading ? classes.push('btn--loading-blue') : classes;

  if (status === 'favorite') {
    classes.push('btn--outline');

    return (
      <div className="popup" data-type="alert" data-status="warning">
        <div className="popup__aside">
          <div className="card-popup__pic" />
        </div>
        <div className="popup__content">
          <div className="popup__content-inner popup__content-inner--wide">
            <h3 className="heading heading--1 popup__title">
              Фильм в избранном!
            </h3>
            <p className="popup__txt">
              Мы вам напишем о ближайших сеансах этого фильма.
            </p>
          </div>
        </div>
        <button className="popup__close" type="button">
          <svg viewBox="0 0 18 18" width="18" height="18">
            <path d="M15.5 17.6l-6.5-6.5-6.5 6.5c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l6.5-6.5-6.5-6.5c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l6.5 6.5 6.5-6.5c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-6.5 6.5 6.5 6.5c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4s-.8-.2-1.1-.4z" />
          </svg>
        </button>
      </div>
    );
  }

  if (status === 'empty_day') {
    classes.push('btn--outline');

    return (
      <div className="popup" data-type="alert" data-status="warning">
        <div className="popup__aside">
          <div className="card-popup__pic" />
        </div>
        <div className="popup__content">
          <div className="popup__content-inner popup__content-inner--wide">
            <h3 className="heading heading--1 popup__title">
              Сеансы скоро будут
            </h3>
            <p className="popup__txt">
              В данный момент сеансы на эту дату не загружены. Вы сможете
              приобрести билеты на этот день как только они станут доступны.
            </p>
            <div className="popup__btn-wrap">
              <div className="wrap">
                <button
                  className="btn"
                  type="button"
                  onClick={() => $.magnificPopup.close()}
                >
                  Выбрать другой день
                </button>
              </div>
            </div>
          </div>
        </div>
        <button className="popup__close" type="button">
          <svg viewBox="0 0 18 18" width="18" height="18">
            <path d="M15.5 17.6l-6.5-6.5-6.5 6.5c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l6.5-6.5-6.5-6.5c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l6.5 6.5 6.5-6.5c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-6.5 6.5 6.5 6.5c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4s-.8-.2-1.1-.4z" />
          </svg>
        </button>
      </div>
    );
  }

  function handleClick(e) {
    e.preventDefault();

    if (func) {
      func();
    } else {
      $.magnificPopup.close();
    }
  }

  return (
    <div className="popup" data-type="alert" data-status={status}>
      <div className="popup__aside">
        <div className="card-popup__pic" />
      </div>
      <div className="popup__content">
        <div className="popup__content-inner">
          <h3 className="heading heading--1 popup__title">
            {isBlankString(title) ? defaults.titles[status] : title}
          </h3>
          {isBlankString(message) ? null : (
            <p className="popup__txt">{message}</p>
          )}
          <div className="popup__btn-wrap">
            <div className="wrap">
              {status === 'warning' ? (
                <button
                  className="btn"
                  type="button"
                  onClick={() => $.magnificPopup.close()}
                >
                  Назад
                </button>
              ) : null}
              {isBlankString(link) ? (
                <button
                  className={classes.join(' ')}
                  type="button"
                  onClick={handleClick}
                >
                  {btn}
                </button>
              ) : (
                <a
                  href={link}
                  className={classes.join(' ')}
                  onClick={() => {
                    if (message === 'Вы действительно хотите отменить заказ?') {
                      setIsLoading(true);
                      setCookie('UNPAID_ORDER', '');
                    }
                  }}
                >
                  <span>{btn}</span>
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
      <button className="popup__close" type="button">
        <svg viewBox="0 0 18 18" width="18" height="18">
          <path d="M15.5 17.6l-6.5-6.5-6.5 6.5c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l6.5-6.5-6.5-6.5c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l6.5 6.5 6.5-6.5c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-6.5 6.5 6.5 6.5c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4s-.8-.2-1.1-.4z" />
        </svg>
      </button>
    </div>
  );
}

export default AlertPopup;
